import React, {
  createContext,
  ReactElement,
  ReactNode,
  useContext,
  useState
} from 'react'

type GlobalContextType = {
  setActiveService: (props: ActiveService) => void
  service: ActiveService
}

type ActiveService = {
  name?: string
  type?: string
  slug?: string
}

// default values are added in the component
export const AuthContext = createContext<GlobalContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setActiveService: () => {},
  service: {}
})

const GlobalStateProvider = ({
  children
}: {
  children: ReactNode
}): ReactElement => {
  const [service, setService] = useState<ActiveService>({})

  const setActiveService = (props: ActiveService) => {
    setService(props)
  }

  return (
    <AuthContext.Provider value={{ setActiveService, service }}>
      {children}
    </AuthContext.Provider>
  )
}

// hooks for accessing context
const useGlobalState = (): GlobalContextType => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useGlobalState must be used within a GlobalStateProvider')
  }
  return context
}

export { GlobalStateProvider, useGlobalState }
